<template>
  <div class="plugin-wrapper py-9 px-11 d-flex align-center">
    <a class="plugin-wrapper__icon d-flex" href="/plugindownload/autodesk/" :title="$t('Скачать плагин')" target="_blank" @click="logDownloadPluginBIMLIBCAD">
      <img class="plugin__icon" src="/dist/assets/front_white/img/landing_plugin/plugin__settings.svg" />

      <div class="plugin__info d-flex flex-column justify-center pl-9">
        <div class="d-flex">
          <div class="plugin__info-title">{{ $t("Плагин BIMLIB") }}</div>
          <img alt="" src="/dist/assets/front_white/img/landing_plugin/icon-done-filled-small.svg" />
        </div>
        <div class="d-flex">
          <img alt="" src="/dist/assets/front_white/img/landing_plugin/rating-full.svg" />
          <img alt="" src="/dist/assets/front_white/img/landing_plugin/rating-full.svg" />
          <img alt="" src="/dist/assets/front_white/img/landing_plugin/rating-full.svg" />
          <img alt="" src="/dist/assets/front_white/img/landing_plugin/rating-full.svg" />
          <img alt="" src="/dist/assets/front_white/img/landing_plugin/rating-half.svg" />
          <div class="plugin__info-version pl-6">{{ $t("Версия") }} 1.2</div>
        </div>
      </div>
    </a>

    <div class="vertical-delimiter"></div>

    <div class="d-flex align-center">
      <img alt="" src="/dist/assets/front_white/img/icon_plugins/revit-logo.png" width="30px" height="38px"  class="plugin__icon-manufacturer" />
      <img alt="" src="/dist/assets/front_white/img/icon_plugins/autocad.png" width="36px" height="36px" class="plugin__icon-manufacturer" />
      <img alt="" src="/dist/assets/front_white/img/icon_plugins/civil.png" width="31px" height="40px" class="plugin__icon-manufacturer" />
      <div class="plugin__icon-manufacturer">
        <img alt="" src="/dist/assets/front_white/img/icon_plugins/archi.png" width="46px" height="47px" class="plugin__icon-manufacturer--disable" />
        <bimTooltip>{{ $t("Скоро") }}</bimTooltip>
      </div>
      <div class="plugin__icon-manufacturer">
        <img alt="" src="/dist/assets/front_white/img/icon_plugins/nanocad.png" width="34px" height="37px" class="plugin__icon-manufacturer--disable" />
        <bimTooltip>{{ $t("Скоро") }}</bimTooltip>
      </div>
      <div class="plugin__icon-manufacturer">
        <img alt="" src="/dist/assets/front_white/img/icon_plugins/renga.png" width="37px" height="41px" class="plugin__icon-manufacturer--disable" />
        <bimTooltip>{{ $t("Скоро") }}</bimTooltip>
      </div>
    </div>

    <a href="/plugindownload/autodesk/" @click="logDownloadPluginBIMLIBCAD" target="_blank" class="d-block plugin-link">
      <bimButton size="l" :label="$t('Скачать плагин')" class="plugin-link__button" />
    </a>
  </div>
</template>

<script>
import bimTooltip from "@bimlib/components/bimTooltip"
import bimButton from "@bimlib/components/bimButton"
import { logDownloadPluginBIMLIBCAD } from "@/utils/logEvents.js"
export default {
  name: "BlockDownloadPlugin",
  components: {
    bimTooltip,
    bimButton
  },
  methods: {
    logDownloadPluginBIMLIBCAD,
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";

.plugin-wrapper {
  max-width: 1400px;
  width: 100%;
  background-color: $white-color;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.05);
  border-radius: 5px;

  .plugin-wrapper__icon {
    cursor: pointer;
  }

  .plugin__icon {
    width: 68px;
    height: 68px;
  }

  .plugin__icon-manufacturer {
    &:not(:last-child) {
      margin-right: 18px;
    }
  }

  .plugin__icon-manufacturer--disable {
    opacity: .25;
  }

  .plugin__info-title {
    line-height: 1.3;
    font-size: 20px;
    font-weight: bold;
  }

  .plugin__info-version {
    line-height: 1.57;
    letter-spacing: 0.2px;
    font-size: 14px;
  }

  .plugin-link {
    margin-left: auto;
  }

  .plugin-link__button {
    line-height: 1.44;
    font-size: 18px;
    font-weight: bold;
    padding: 21px 24px;
  }
}

.vertical-delimiter {
  width: 1px;
  height: 64px;
  background-color: $white-color-300;
  margin-right: 41px;
  margin-left: 50px;
}
</style>
